/** Global in-flight processing counter for mutating / long-running API work. */

export type ProcessingListener = (state: { count: number; label: string | null }) => void;

let count = 0;
let label: string | null = null;
const listeners = new Set<ProcessingListener>();

function notify() {
  const snapshot = { count, label };
  listeners.forEach((listener) => listener(snapshot));
}

export function subscribeProcessing(listener: ProcessingListener): () => void {
  listeners.add(listener);
  listener({ count, label });
  return () => {
    listeners.delete(listener);
  };
}

export function beginProcessing(nextLabel = 'Processing…'): void {
  count += 1;
  label = nextLabel;
  notify();
}

export function endProcessing(): void {
  count = Math.max(0, count - 1);
  if (count === 0) label = null;
  notify();
}

export function processingLabelForMethod(method: string): string {
  const m = method.toUpperCase();
  if (m === 'POST') return 'Saving…';
  if (m === 'PUT' || m === 'PATCH') return 'Updating…';
  if (m === 'DELETE') return 'Deleting…';
  return 'Processing…';
}
